<template>
  <!-- 新增的对话框 修改楼盘佣金 -->
  <el-dialog
    center
    width="750px"
    :title="title"
    :visible.sync="dialogFormVisible"
    @opened="getLoad"
    @close="resetFrom()"
  >
    <el-form :model="editForm" :rules="editRules" ref="editForm">
      <el-form-item
        label="售佣金结算方式"
        :label-width="formLabelWidth"
        prop="type"
      >
        <el-radio-group v-model="editForm.type" @change="handleRadioChange">
          <el-radio :label="1">固定金额佣金</el-radio>
          <el-radio :label="2">楼盘总价*楼盘点数</el-radio>
        </el-radio-group>
      </el-form-item>
      <template v-if="editForm.type == 2">
        <el-form-item
          label="售佣金比例"
          :label-width="formLabelWidth"
          prop="rate"
        >
          <el-input-number
            v-model="editForm.rate"
            :precision="2"
            autocomplete="off"
          ></el-input-number>
          <span style="color: red">（楼盘总价 * 售佣金比例）</span>
        </el-form-item>
        <el-form-item
          v-if="IsOverdue == 0"
          label="租佣金基数"
          :label-width="formLabelWidth"
          prop="rentBasePoint_2"
        >
          <!-- :precision="1" :step="0.5"  -->
          <el-input-number
            type="number"
            v-model="editForm.rentBasePoint_2"
            :min="0"
            autocomplete="off"
          ></el-input-number>
          <span style="color: red">（租佣金基数 * 月租金）</span>
        </el-form-item>
      </template>
      <template v-else-if="editForm.type == 1">
        <el-form-item
          label="售佣金金额"
          :label-width="formLabelWidth"
          prop="commission"
        >
          <el-input-number
            type="number"
            v-model="editForm.commission"
            autocomplete="off"
          ></el-input-number>
        </el-form-item>
        <el-form-item
          v-if="IsOverdue == 0"
          label="租佣金金额"
          :label-width="formLabelWidth"
          prop="rentBasePoint_1"
        >
          <!-- :precision="1" :step="0.5"  -->
          <el-input-number
            type="number"
            v-model="editForm.rentBasePoint_1"
            :min="0"
            autocomplete="off"
          ></el-input-number>
        </el-form-item>
      </template>

      <!-- 0:未过期 1：已经过期 -->
      <template v-if="IsOverdue == 0">
        <el-form-item
          label="有效期"
          :label-width="formLabelWidth"
          prop="expireDate"
        >
          <el-date-picker
            v-model="editForm.expireDate"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>
      </template>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button
        @click="
          resetFrom();
          dialogFormVisible = false;
        "
        >取 消</el-button
      >
      <el-button type="primary" style="margin: 0 10px" @click="handleSubmit"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { formRateData, formRateRules } from '../form.js';
import {
  setValidityPeriod,
  updateBouns,
  rateByHouseRateIdApi,
  addCommisionApi,
  updateCommisionApi,
} from '@/api/houseApi.js'; //

export default {
  name: 'editHousesRate',
  data() {
    return {
      title: '',
      rateType: 1,
      houseId: '',
      dialogTitle: '',
      formLabelWidth: '130px', // 对话框中 文本的尺寸
      dialogFormVisible: false, // 是否显示对话框
      editForm: { ...formRateData, rentBasePoint_1: '', rentBasePoint_2: '' }, // 编辑表单
      editRules: formRateRules, // 表单的验证规则
      expireDate: [],
      IsOverdue: '', // 是否已经过期了
      houseRateId: '',
    };
  },
  inject: ['reload'],
  computed: {},
  mounted() {},
  methods: {
    resetFrom() {
      // this.editForm = {};
      this.$refs.editForm.resetFields();
    },
    getLoad() {
      if (this.title == '增加楼盘佣金') return;
      rateByHouseRateIdApi({ houseRateId: this.houseRateId }).then((res) => {
        if (res.data == null) return;
        // this.editForm = res.data;
        let data = res.data;
        this.editForm = {
          commission: data.validityFixedBonus,
          // data.validityCalculateType == 1
          //   ? data.validityFixedBonus
          //   : data.validityBonusPoint, // 佣金金额
          expireDate: [data.validityStartTime, data.validityEndTime], // 有效期
          price: '', // 楼盘总价
          rate: data.validityBonusPoint, // 佣金比例
          type: data.validityCalculateType, // 结算类型
          rentBasePoint_1: data.rentBasePoint,
          rentBasePoint_2: data.rentBasePoint,
        };
        // console.log('form', this.editForm);
        // console.log('修改佣金初始化：', res.data);
      });
    },
    // 切换radio
    handleRadioChange(val) {
      console.log(val);
      // let fieled = val == 1 ? 'rentBasePoint_1' : 'rentBasePoint_2';
      // this.$refs['editForm'].resetFields(fieled);
      // this.editForm.type = val;
    },
    submitEdit() {
      try {
        this.$refs.editForm.validate(async (valid) => {
          // if(!valid) return this.$message.error("格式不对哦，检查一下呗!")
          if (valid) {
            if (this.houseId != '') {
              const form = this.editForm;
              form['rentBasePoint'] =
                this.editForm.type == 1
                  ? this.editForm.rentBasePoint_1
                  : this.editForm.rentBasePoint_2;
              // let data= {
              //   houseId:this.houseId,
              //   type:form.type,
              //   bounce: form.type==1?form.rate:form.commission,
              //   startTime:form.expireDate[0],
              //   endTime:form.expireDate[1]
              // }

              let stringData = '';
              if (this.IsOverdue == 0) {
                stringData = `houseId=${this.houseId}&type=${form.type}&bonus=${
                  form.type == 2 ? form.rate : form.commission
                }&startTime=${form.expireDate[0]}&endTime=${
                  form.expireDate[1]
                }&rentBasePoint=${form.rentBasePoint}`;
                await setValidityPeriod(stringData).then((res) => {
                  if (res.code === 200) {
                    this.$message.success('编辑成功!');
                  } else {
                    this.$message.error('编辑失败!');
                    return;
                  }
                });
              } else {
                // delete data.startTime
                // delete data.endTime
                stringData = `houseId=${this.houseId}&type={form.type}&bonus=${
                  form.type == 1 ? form.rate : form.commission
                }`;
                await updateBouns(stringData).then((res) => {
                  if (res.code === 200) {
                    this.$message.success('编辑成功!');
                  } else {
                    this.$message.error('编辑失败!');
                    return;
                  }
                });
              }
            }
            this.dialogFormVisible = false;
            this.editForm = {};
            // 重新获取数据
            this.reload();
          }
        });
      } catch (e) {
        window.console.log(e);
      }
    },

    // 新增/编辑
    handleSubmit() {
      try {
        this.$refs.editForm.validate(async (valid) => {
          if (valid) {
            if (this.houseId != '') {
              const form = this.editForm;
              form['rentBasePoint'] =
                this.editForm.type == 1
                  ? this.editForm.rentBasePoint_1
                  : this.editForm.rentBasePoint_2;
              let houseRateId =
                this.title == '增加楼盘佣金' ? '' : this.houseRateId;
              let data = {
                houseRateId,
                houseId: this.houseId,
                type: form.type,
                startTime: form.expireDate[0],
                endTime: form.expireDate[1],
                rentBasePoint: form.rentBasePoint,
                bonus: form.type == 2 ? form.rate : form.commission,
              };
              if (this.title == '增加楼盘佣金') {
                await addCommisionApi(data).then((res) => {
                  if (res.code === 200) {
                    this.$message.success('添加成功!');
                    this.dialogFormVisible = false;
                  } else {
                    // this.$message.error('添加失败!');
                    return;
                  }
                });
              } else {
                await updateCommisionApi(data).then((res) => {
                  if (res.code === 200) {
                    this.$message.success('编辑成功!');
                    this.dialogFormVisible = false;
                  } else {
                    // this.$message.error('编辑失败!');
                    return;
                  }
                });
              }
            }
            this.$emit('reload');
            // this.editForm = {};
            // 重新获取数据
            // this.reload();
          }
        });
      } catch (e) {
        window.console.log(e);
      }
    },
  },
  created() {},
};
</script>

<style></style>
